// extracted by mini-css-extract-plugin
module.exports = {"container-timer":"Timer_container-timer__1yU-V","timer":"Timer_timer__-0kpB"};